import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { theme } from '../styles/theme';

// Totale iscritti degli eventi visibili, mostrato a destra dei filtri
function AttendeesTotal({ total, loading }) {
  return (
    <span style={styles.total} title="Totale iscritti degli eventi in elenco">
      <FontAwesomeIcon icon={faUsers} style={styles.icon} />
      {loading ? '…' : total}
    </span>
  );
}

const styles = {
  total: {
    marginLeft: 'auto',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    borderRadius: '16px',
    fontSize: '13px',
    fontWeight: 'bold',
    color: theme.colors.brand,
    backgroundColor: theme.colors.white,
    border: `1px solid ${theme.colors.brand}`,
  },
  icon: {
    fontSize: '13px',
  },
};

export default AttendeesTotal;
